import * as types from './actionTypes';
import rest from "../API/api";
//import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';

export function loadSubscriptionsSuccess(subscriptions) {
    //debugger;
  return {type: types.LOAD_SUBSCRIPTION_SUCCESS, subscriptions};
}

export function deleteSubscriptionsSuccess(subscriptions) {
    //debugger;
    return {type: types.DELETE_SUBSCRIPTION_SUCCESS, subscriptions};
}

export function updateSubscriptionsSuccess(subscriptions) {
    //debugger;
    return {type: types.UPDATE_SUBSCRIPTION_SUCCESS, subscriptions};
}

export function addSubscriptionsSuccess(subscriptions) {
    //debugger;
    return {type: types.ADD_SUBSCRIPTION_SUCCESS, subscriptions};
}

export function readSubscriptionSuccess(subscription) {
    //debugger;
    return {type: types.READ_SUBSCRIPTION_SUCCESS, subscription};
}


// Functions below handle asynchronous calls.
// Each returns a function that accepts a dispatch.
// These are used by redux-thunk to support asynchronous interactions.
export function loadSubscriptions(tenant) {
    return function (dispatch) {
        fetch(rest.subscriptions, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {

                //debugger;
                // turn the JSON into a string then into an JS array
               return dispatch(loadSubscriptionsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}

//Makes an API call to the gateway which will update the subscription with mongoDB_id that matches the one passed on the URL. API call
//will return the current set of records after the deletion so we will dispatch a store update with the new records.
export function updateSubscription(tenant,subscription) {
    return function (dispatch) {
        //lets define some const. that we can use in the fetch calls below
        //REST API Gateway URLs
        let tempURL = rest.subscription + '/' + subscription.id;
        //Current Subscription record that we will need to update
        const subscriptionID = subscription.id;
         //Update the main MongoDB record
        fetch(tempURL, {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            }),
            body: JSON.stringify({
                RequestingTenantId: subscription.RequestingTenantId,
                EventType: subscription.EventType,
                Userid: subscription.Userid,
                Kioskid: subscription.Kioskid,
                Email: subscription.Email,
                Company: subscription.Company,
                Fname: subscription.Fname,
                Lname: subscription.Lname,
                Address: subscription.Address,
                City: subscription.City,
                State: subscription.State,
                Country: subscription.Country,
                Postal: subscription.Postal,
                Phone: subscription.Phone,
                SubscriptionDate: subscription.SubscriptionDate,
                SubscriptionStatus: subscription.SubscriptionStatus,
                SubscriptionType: subscription.SubscriptionType,
                SubscriptionMultiShopCount: subscription.SubscriptionMultiShopCount,
                SubscriptionPrice: subscription.SubscriptionPrice,
                CustomerXRef: subscription.CustomerXRef,
                CCNumber: subscription.CCNumber,
                CCName: subscription.CCName,
                CCExpiry: subscription.CCExpiry,
                CCCvc: subscription.CCCvc,
                CCIssuer: subscription.CCIssuer,
                CCZip: subscription.CCZip,
                UserHash: subscription.UserHash,
                UserSalt: subscription.UserSalt,
                KioskHash: subscription.KioskHash,
                KioskSalt: subscription.KioskSalt,
                Processed: subscription.Processed,
                Notes: subscription.Notes
            }),
        })
            .then(response => response.json())
            .then(data => {
                // turn the JSON into a string then into an JS array
                return dispatch(updateSubscriptionsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}


//Makes an API call to the gateway which will update the subscription with mongoDB_id that matches the one passed on the URL. API call
//will return the current set of records after the deletion so we will dispatch a store update with the new records.
export function addSubscription(tenant,subscription) {
    return function (dispatch) {
        let tempURL = rest.subscription;
        fetch(tempURL, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            }),
            body: JSON.stringify({
                RequestingTenantId: subscription.RequestingTenantId,
                EventType: subscription.EventType,
                Userid: subscription.Userid,
                Kioskid: subscription.Kioskid,
                Email: subscription.Email,
                Company: subscription.Company,
                Fname: subscription.Fname,
                Lname: subscription.Lname,
                Address: subscription.Address,
                City: subscription.City,
                State: subscription.State,
                Country: subscription.Country,
                Postal: subscription.Postal,
                Phone: subscription.Phone,
                SubscriptionDate: subscription.SubscriptionDate,
                SubscriptionStatus: subscription.SubscriptionStatus,
                SubscriptionType: subscription.SubscriptionType,
                SubscriptionMultiShopCount: subscription.SubscriptionMultiShopCount,
                SubscriptionPrice: subscription.SubscriptionPrice,
                CustomerXRef: subscription.CustomerXRef,
                CCNumber: subscription.CCNumber,
                CCName: subscription.CCName,
                CCExpiry: subscription.CCExpiry,
                CCCvc: subscription.CCCvc,
                CCIssuer: subscription.CCIssuer,
                CCZip: subscription.CCZip,
                UserHash: subscription.UserHash,
                UserSalt: subscription.UserSalt,
                KioskHash: subscription.KioskHash,
                KioskSalt: subscription.KioskSalt,
                Processed: subscription.Processed,
                Notes: subscription.Notes
            }),
        })
            .then(response => response.json())
            .then(data => {
                return dispatch(addSubscriptionsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));

    };
}


//Makes an API call to the gateway which will read a subscription with mongoDB_id that matches the one passed on the URL. API call
//will return the current record after the read so we will dispatch a store update with the new records.
export function readSubscription(tenant,id) {
    return function (dispatch) {
        let tempURL = rest.subscription + '/' + id;
        fetch(tempURL, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {
                // turn the JSON into a string then into an JS array
                return dispatch(readSubscriptionSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}


//Makes an API call to the gateway which will delete the subscription with mongoDB_id that matches the one passed on the URL. API call
//will return the current set of records after the deletion so we will dispatch a store update with the new records.
export function deleteSubscription(tenant,id) {
    return function (dispatch) {
        let tempURL = rest.subscription + '/' + id;
        fetch(tempURL, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {

                // turn the JSON into a string then into an JS array
                return dispatch(deleteSubscriptionsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}



// WEBPACK FOOTER //
// ./src/actions/subscriptionActions.js